module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "toc"
    }
  }, [_c('p', {
    staticClass: "ctfm"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.v"
    }
  }), _vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "tocfm"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0005#PRE1",
      "id": "rPRE1"
    }
  }, [_vm._v("Editor’s Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "tocfm"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0006#PRE2",
      "id": "rPRE2"
    }
  }, [_vm._v("Author’s Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "tocfm"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR",
      "id": "rABBR"
    }
  }, [_vm._v("Abbreviations")])]), _vm._v(" "), _c('p', {
    staticClass: "tocfm"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0008#BIBLIO",
      "id": "rBIBLIO"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "tocpt"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0009#INTRO",
      "id": "rINTRO"
    }
  }, [_vm._v("INTRODUCTION")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0009#INTRO.1",
      "id": "rINTRO.1"
    }
  }, [_vm._v("I. General Circumstances")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0009#INTRO.2",
      "id": "rINTRO.2"
    }
  }, [_vm._v("II. Integrity, Literary History, and Text")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0009#INTRO.3",
      "id": "rINTRO.3"
    }
  }, [_vm._v("III. Audience")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0009#INTRO.4",
      "id": "rINTRO.4"
    }
  }, [_vm._v("IV. Nature and Genre")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0009#INTRO.5",
      "id": "rINTRO.5"
    }
  }, [_vm._v("V. Purpose")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0009#INTRO.6",
      "id": "rINTRO.6"
    }
  }, [_vm._v("VI. Theme")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0009#INTRO.7",
      "id": "rINTRO.7"
    }
  }, [_vm._v("VII. Text and Translation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0009#INTRO.8",
      "id": "rINTRO.8"
    }
  }, [_vm._v("VIII. Structure")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0009#INTRO.9",
      "id": "rINTRO.9"
    }
  }, [_vm._v("IX. Analysis of Romans")])]), _vm._v(" "), _c('p', {
    staticClass: "tocpt"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011#pt01",
      "id": "rpt01"
    }
  }, [_vm._v("TEXT, EXPOSITION, AND NOTES")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011#BODY1",
      "id": "rBODY1"
    }
  }, [_vm._v("I. The Letter Opening (1:1–17)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011#BODY3",
      "id": "rBODY3"
    }
  }, [_vm._v("II. The Heart of the Gospel: Justification by Faith (1:18–4:25)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011b#BODY5",
      "id": "rBODY5"
    }
  }, [_vm._v("III. The Assurance Provided by the Gospel: The Hope of Salvation (5:1–8:39)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011e#BODY7",
      "id": "rBODY7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "id": "page.vi"
    }
  }), _vm._v("IV. The Defense of the Gospel: The Problem of Israel (9:1–11:36)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011g#BODY8",
      "id": "rBODY8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V. The Transforming Power of the Gospel: Christian Conduct (12:1–15:13)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011h#BODY9",
      "id": "rBODY9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI. The Letter Closing (15:14–16:27)")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbm"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0012#notes",
      "id": "rnotes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "tocpt"
  }, [_vm._v("INDEXES")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0018#INDEX1",
      "id": "rINDEX1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I. Subjects")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0019#INDEX2",
      "id": "rINDEX2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II. Authors")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0020#INDEX3",
      "id": "rINDEX3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III. Scripture References")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0021#INDEX4",
      "id": "rINDEX4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV. Early Extrabiblical Literature")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ea01592","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/eernicnt66ro0004.vue
// module id = 63
// module chunks = 0